import headerModule from './header/header.module';
import footerModule from './footer/footer.module';
import paymentMethodModule from './payment-method/payment-method.module';
import packetComponent from './packet/packet.component';
import packetCardModule from './packet-card/packet-card.module';
import billInfoEditComponent from './bill-info-edit/bill-info-edit.component';
import goToOffersDialogComponent from './go-to-offers-dialog/go-to-offers-dialog.component';
import otpDialogComponent from './otp-dialog/otp-dialog.component';
import otpExpireDialogComponent from './otp-expire-dialog/otp-expire-dialog.component';
import buySuccessDialogComponent from './buy-success-dialog/buy-success-dialog.component';
import billInfoComponent from './bill-info/bill-info.component';
import billInfoAddComponent from './bill-info-add/bill-info-add.component';
import distantSalesDialogComponent from './distant-sales-dialog/distant-sales-dialog.component';
import preInfoFormDialogComponent from './pre-info-form-dialog/pre-info-form-dialog.component';

export default angular
  .module('fizyweb.paycell.noauth.components', [
    headerModule,
    footerModule,
    paymentMethodModule,
    packetCardModule
  ])
  .component('fizyPaycellNoAuthPacket', packetComponent)
  .component('fizyPaycellNoAuthGoToOffersDialog', goToOffersDialogComponent)
  .component('fizyPaycellNoAuthBuySuccessDialog', buySuccessDialogComponent)
  .component('fizyPaycellNoAuthOtpDialog', otpDialogComponent)
  .component('fizyPaycellNoAuthOtpExpireDialog', otpExpireDialogComponent)
  .component('fizyPaycellNoAuthBillInfo', billInfoComponent)
  .component('fizyPaycellNoAuthBillInfoAdd', billInfoAddComponent)
  .component('fizyPaycellNoAuthBillInfoEdit', billInfoEditComponent)
  .component('fizyPaycellNoAuthDistantSalesDialog', distantSalesDialogComponent)
  .component('fizyPaycellNoAuthPreInfoFormDialog', preInfoFormDialogComponent)
  .name;



// WEBPACK FOOTER //
// src/app/no-auth/components/components.module.ts